import React from "react";
import ReactPlayer from "react-player";
import VideoUI from "./img/iep-ui-movie.mp4";

function IEPCardFinal() {
	return (
		<section className="card-iep-final">
			<div className="content-row">
				<article className="content">
					<h2 className="title">Successful delivery and handover</h2>
					<p>
						A first-version launch of the application was achieved within a
						handful of sprint cycles.
					</p>
					<p>
						I had a key role in liaising closely with QA, DevOps, a Systems
						Architect, Product Owners, and the team of developers ensuring a
						high quality outcome. The standard for this application UI greatly
						exceeded all other bespoke builds for Ingenio.
					</p>
					<p>
						Having helped the applications team establish a design workflow, I
						then conducted extensive hand-over training for off-shore UX
						practitioners to further build upon the initial launch.
					</p>
				</article>
				<figure className="video">
					<ReactPlayer
						url={VideoUI}
						playing={true}
						controls={true}
						width={"100%"}
						height={"auto"}
					/>
				</figure>
			</div>
		</section>
	);
}

export default IEPCardFinal;
